import {useEffect, useState} from 'react'

/**
 * Resolves a media query client-side only, starting at `null` rather than a guessed default.
 * Useful on statically rendered pages (no request to read a device hint from) where committing to
 * a wrong first guess -- e.g. mounting a desktop-only widget before swapping to mobile -- can cause
 * work (like a third-party script's network requests) to happen for both variants instead of one.
 */
export const useMatchMedia = (query: string): boolean | null => {
  const [matches, setMatches] = useState<boolean | null>(null)

  useEffect(() => {
    const mediaQueryList = window.matchMedia(query)
    setMatches(mediaQueryList.matches)

    const handleChange = (event: MediaQueryListEvent) => {
      setMatches(event.matches)
    }

    mediaQueryList.addEventListener('change', handleChange)
    return () => mediaQueryList.removeEventListener('change', handleChange)
  }, [query])

  return matches
}
